import React from "react";
import { View, Text, Pressable } from "react-native";
import { REGISTER_ROUTE } from "../../navigation/NavigationConstants";
import { useNavigation } from "@react-navigation/native";
import { styles, ids } from "./styles/LoginButton.styles";
import { labelText } from "../../resources/strings";
import { isRegisterAllowed } from "@lib/utilities/SettingsUtil";

const SignUpSection = () => {
  const navigation = useNavigation();
  return (
    <View style={styles.loginHere} testID="login-page-signup-label-button-container">
      <Text
        dataSet={{ media: ids.whiteTextSmall }}
        style={styles.whiteTextSmall}
        testID="login-page-no-account-label"
      >
        {labelText.login.dontHaveAccount}{" "}
      </Text>
      <Pressable onPress={() => navigation.navigate(REGISTER_ROUTE as never)} testID="login-page-signup-button">
        <Text style={styles.loginLink} testID="login-page-signup-button-label">{labelText.button.signup}</Text>
      </Pressable>
    </View>
  );
};

const LoginButton = ({ onLoginPress }: { onLoginPress: () => void }) => {
  return (
    <View style={styles.container} testID="login-page-login-signup-section-container">
      <Pressable
        dataSet={{ media: ids.buttonLogin }}
        style={styles.buttonLogin}
        onPress={onLoginPress}
        testID="login-page-login-button"
      >
        <Text dataSet={{ media: ids.whiteText }} style={styles.whiteText} testID="login-page-login-button-label">
          {labelText.button.login}
        </Text>
      </Pressable>
      {isRegisterAllowed() ? <SignUpSection /> : null}
    </View>
  );
};

export default LoginButton;
